var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('canvas',{ref:"myCanvas",attrs:{"id":"myCanvas","width":"32","height":"32"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }